export const PATH_HOME = '/';
export const PATH_LOGIN = '/login';
export const PATH_SIGNUP = '/signup';
export const PATH_FORGOT_PASSWORD = '/forgot-password';
export const PATH_RESET_PASSWORD = '/reset-password';
export const PATH_CHANGE_PASSWORD = '/change-password';

export const PATH_REELS = '/reels/:id/*';
export const PATH_MEDIA = '/m/:id/*';
export const PATH_CHANNEL = '/m/channel/:chId/*';
export const PATH_CHANNEL_SUBSCRIBERS = '/m/channel/:chId/subscribers';
export const PATH_PLAYLIST = '/p/:id/*';
export const PATH_LEGACY_SERIES = '/s/:id/*';
export const PATH_CONTENT_LIST = '/n/:id/*';

export const PATH_SEARCH = '/q/*';
export const PATH_ABOUT = '/o/about';
export const PATH_ACTIVATETV = '/activate';
export const PATH_APPLE_FILE = '/.well-known/apple-app-site-association';

export const PATH_USER_BASE = '/u';
export const PATH_USER = `${PATH_USER_BASE}/*`;

export const PATH_VIDEO_PREVIEW = '/video-preview';
export const PATH_VIDEO_PREVIEW_WITH_ID = '/video-preview/:id';
export const PATH_VIDEO_PREVIEW_CHANNEL = '/video-preview/:chId/:id/*';
export const PATH_CHENNAL_PREVIEW = '/content-preview';
export const PATH_CHENNAL_PREVIEW_WITH_ID = '/content-preview/:id';
export const PATH_MY_VIDEO_DETAILS = '/my-video-details';
export const PATH_MY_VIDEO_DETAILS_WITH_ID = '/my-video-details/:id';
export const PATH_BROADCAST_LIVE_DETAILS = '/broadcast-live-details';
export const PATH_BROADCAST_LIVE_DETAILS_WITH_ID = '/broadcast-live-details/:id';
export const PATH_BROADCAST_LIVE_PLAY = '/broadcast-live-play';
export const PATH_BROADCAST_LIVE_PLAY_WITH_ID = '/broadcast-live-play/:id';
export const PATH_REPORTS_DETAILS = '/reports-details';
export const PATH_REPORTS_DETAILS_WITH_ID = '/reports-details/:id';

export const RELATIVE_PATH_USER_ACCOUNT = 'my-account';
export const RELATIVE_PATH_USER_MY_PROFILE = 'my-profile/:id';
export const RELATIVE_PATH_USER_FAVORITES = 'favorites';
export const RELATIVE_PATH_USER_NOTIFICATIONS = 'notifications';
export const RELATIVE_PATH_USER_PAYMENTS = 'payments';
export const RELATIVE_PATH_USER_PROFILES = 'profiles';
export const RELATIVE_PATH_USER_MY_SUBSCRIPTION = 'my-subscription';
export const RELATIVE_PATH_USER_SETTINGS = 'settings';
export const RELATIVE_PATH_USER_PRIVACY_POLICY = 'privacy-policy';
export const RELATIVE_PATH_USER_TERMS_OF_USE = 'terms-of-use';
export const RELATIVE_PATH_USER_SIGN_OUT = 'signout';
export const RELATIVE_PATH_USER_DELETE_ACCOUNT = 'delete-account';
export const RELATIVE_PATH_USER_SEEMORE_ITEMS = '/:id/see-more-items';
export const RELATIVE_PATH_CHECKOUT = 'payment-checkout';
export const RELATIVE_PATH_USER_VIDEOS = 'videos';
export const RELATIVE_PATH_USER_MODERATE = 'moderate';
export const RELATIVE_PATH_REPORTS = 'reports';

export const PATH_USER_ACCOUNT = `${PATH_USER_BASE}/${RELATIVE_PATH_USER_ACCOUNT}`;
export const PATH_USER_SETTINGS = `${PATH_USER_BASE}/${RELATIVE_PATH_USER_SETTINGS}`;
export const PATH_USER_PRIVACY_POLICY = `${PATH_USER_BASE}/${RELATIVE_PATH_USER_PRIVACY_POLICY}`;
export const PATH_USER_TERMS_OF_USE = `${PATH_USER_BASE}/${RELATIVE_PATH_USER_TERMS_OF_USE}`;
export const PATH_USER_DELETE_ACCOUNT = `${PATH_USER_BASE}/${RELATIVE_PATH_USER_DELETE_ACCOUNT}`;
export const PATH_USER_MY_PROFILE = `${PATH_USER_BASE}/${RELATIVE_PATH_USER_MY_PROFILE}`;
export const PATH_USER_FAVORITES = `${PATH_USER_BASE}/${RELATIVE_PATH_USER_FAVORITES}`;
export const PATH_USER_NOTIFICATIONS = `${PATH_USER_BASE}/${RELATIVE_PATH_USER_NOTIFICATIONS}`;
export const PATH_USER_PAYMENTS = `${PATH_USER_BASE}/${RELATIVE_PATH_USER_PAYMENTS}`;
export const PATH_USER_PROFILES = `${PATH_USER_BASE}/${RELATIVE_PATH_USER_PROFILES}`;
export const PATH_USER_PROFILES_CREATE = `${PATH_USER_BASE}/${RELATIVE_PATH_USER_PROFILES}/create`;
export const PATH_USER_PROFILES_EDIT = `${PATH_USER_BASE}/${RELATIVE_PATH_USER_PROFILES}/edit`;
export const PATH_USER_PROFILES_EDIT_PROFILE = `${PATH_USER_BASE}/${RELATIVE_PATH_USER_PROFILES}/edit/:id`;
export const PATH_USER_VIDEOS = `${PATH_USER_BASE}/${RELATIVE_PATH_USER_VIDEOS}`;
export const PATH_USER_MODERATE = `${PATH_USER_BASE}/${RELATIVE_PATH_USER_MODERATE}`;
export const PATH_CHANNEL_REPORTS = `${PATH_USER_BASE}/${RELATIVE_PATH_REPORTS}`;
